export default __webpack_public_path__ + "static/zyugyou-67405f5bd5feae0f77bae6c9b5216d87.pdf";